import { pitchNames } from "./audioTools";

export default class Location {
	pitch = 0;
	number = 4;

	constructor(pitch, number) {
		this.pitch = pitch;
		this.number = number;
	}

	next() {
		let numPitches = pitchNames.length;

		let nextPitch = this.pitch + 1;
		let nextNumber = this.number;

		if (nextPitch >= numPitches) {
			nextPitch = 0;
			nextNumber = nextNumber + 1;
		}

		return new Location(nextPitch, nextNumber);
	}
}
